import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sweeperStatus',
})
export class SweeperStatusPipe implements PipeTransform {

  transform(bitNumber: number, flags: number): string {
    if (flags !== undefined && flags !== null && typeof bitNumber === 'number') {
      // tslint:disable-next-line:no-bitwise
      return (flags & Math.pow(2, bitNumber)) === 0 ? 'Not Sweeping' : 'Sweeping';
    } else {
      // null or undefined
      return 'N/A';
    }
  }
}
